import React, {useRef} from 'react';
import './DynaInput.scss';
import UtilsFunctions from "../../../utils/UtilsFunctions";

const DynaInput = (props) => {

  const inputRef = useRef(null);

  const onChangeHandler = (e) => {

    const removeLeadingZeros = (val) => val.replace(/^0+(?!$)/, "");
    if (props.hasComma) {
      const {name, value} = e.target;
      const cleanValue = UtilsFunctions.removeCommas(value);
      if (!isNaN(parseFloat(+cleanValue)) && !cleanValue.includes(".")) {
        const newValue = removeLeadingZeros(cleanValue);
        if (newValue !== "" && newValue !== " " && newValue !== "0" && newValue !== "00") {
          props.setDataFromComponent({[name]: newValue})
        } else {
          props.setDataFromComponent({[name]: 0})
        }
      }
    } else {
      const {name, value} = e.target;
      props.setDataFromComponent({[name]: value})
    }
  }

  const onFocusHandler = () => {
    if (inputRef.current) {
      inputRef.current.select();
    }
  }

  try {
    return (
      <div className={`main-dyna-input ${props.className !== undefined ? props.className : ""}`}
           style={props.style ? props.style : {}}>
        <label htmlFor={props.name}>{props.label}</label>
        <input
          id={props.id}
          ref={inputRef}
          className={`dyna-element ${props.classNameInput !== undefined ? props.classNameInput : ""}`}
          name={props.name}
          type={props.type}
          placeholder={props.placeholder}
          value={(props.value)}
          style={props.styleInput}
          disabled={props.disabled}
          onFocus={onFocusHandler}
          onChange={(e) => onChangeHandler(e)}
        />
      </div>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default DynaInput;